import { BlockEditProps } from "@wordpress/blocks";
import React from "react";
import type { BlockAttributes } from "./block.json";
import {
  InspectorControls,
  RichText,
  useBlockProps,
} from "@wordpress/block-editor";
import FileEditor from "../../../source/components/FileEditor";
import { PanelBody } from "@wordpress/components";

export default function DownloadLinkEditor(
  props: BlockEditProps<BlockAttributes>
) {
  const blockProps = useBlockProps();
  const { attributes, setAttributes } = props;

  return (
    <>
      <InspectorControls>
        <PanelBody title="File Settings" initialOpen={true}>
          <FileEditor
            attributes={attributes}
            setAttributes={setAttributes}
            prefix="file"
            placeholderClassName="components-placeholder--file-selector"
          />
        </PanelBody>
      </InspectorControls>

      <div {...blockProps}>
        <div className="download-preview">
          {attributes.fileUrl ? (
            <div className="file-selected">
              <div className="button-wrapper d-flex align-items-center">
                <div className="button download p-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 20"
                    id="Download--Streamline-Sharp-Material"
                    height="50"
                    width="50"
                  >
                    <path
                      fill="#ffffff"
                      d="m10 13.479166666666668 -4.020833333333334 -4.020833333333334 0.8958333333333334 -0.8958333333333334 2.5 2.5V3.3333333333333335h1.25v7.729166666666667l2.5 -2.5 0.8958333333333334 0.8958333333333334L10 13.479166666666668ZM3.3333333333333335 16.666666666666668V12.437500000000002h1.25V15.416666666666668h10.833333333333334v-2.979166666666667h1.25V16.666666666666668H3.3333333333333335Z"
                      stroke-width="0.4167"
                    ></path>
                  </svg>
                </div>
                <p className="copy-s ps-4">
                  <RichText
                    value={attributes.title || ""}
                    onChange={(title) => setAttributes({ title })}
                    placeholder="Download Link Title"
                    className="download"
                  />
                </p>
              </div>

              <div className="file-info">
                {/* Display filename from URL */}
                <p className="filename">
                  Selected file:{" "}
                  {attributes.fileUrl.substring(
                    attributes.fileUrl.lastIndexOf("/") + 1
                  )}
                </p>
              </div>
            </div>
          ) : (
            <div className="file-selector-main">
              {/* Main file selector in block (alternative to sidebar) */}
              <FileEditor
                attributes={attributes}
                setAttributes={setAttributes}
                prefix="file"
                placeholderClassName="components-placeholder--file-selector-main"
              />
              <p className="helper-text">
                Select a file or use the sidebar settings
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
